import { io } from "socket.io-client";

export const socket = io(import.meta.env.VITE_SOCKET_BASE_URL, {
  autoConnect: false,
  withCredentials: true,
  closeOnBeforeunload: true,

  reconnectionAttempts: 5,
  reconnectionDelay: 1000,

  transports: ["websocket"],
});
